import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbEvento } from 'app/abstract/full-pages/evento/evento.abstract';


@Injectable({ providedIn: 'root' })
export class EventoService extends AbEvento {

  constructor(http: HttpClient) {
    super(http);
  }

  public getEventos(): Observable<any> {
    return this.get(`evento/all`);
  }
}